import React, {useEffect, useState} from 'react'
import './Completed.css'
import RequItem from '../requestItem/RequItem'
import {getCompletedRequ} from '../../../../actions/localAID'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import notFound from '../../../../assets/notThere.png'
import { useTranslation } from "react-i18next";
import Loading from '../../../ui/loading'


const Completed = () => {
    const dispatch = useDispatch();
    let userLogin = JSON.parse(localStorage.getItem('userLogin'))
    const { t } = useTranslation();
    let lng = JSON.parse(localStorage.getItem('language'))?.lang;
    const [innerLoading, setInnerLoading] = useState(true)

    useEffect(()=> {
        if (userLogin?.Results[0]?.person_id!=='') {
            if (lng==='arab') {
                dispatch(getCompletedRequ('AR',userLogin?.Results[0]?.person_id))
            } else {
                dispatch(getCompletedRequ('EN',userLogin?.Results[0]?.person_id))
            }
        }
      }, [lng]);
      const laCompleted = useSelector(state=> state.laCompleted);
    const [completedRequ, setCompletedRequ] = useState(laCompleted?.Local_Aids_Info?.slice(0))
    useEffect(()=> {
        setCompletedRequ(laCompleted?.Local_Aids_Info?.slice(0))
        if (laCompleted.hasOwnProperty('Local_Aids_Info')) {
            setInnerLoading(false)
        }
    }, [laCompleted])
        return (
            <div className='pending'>
                {completedRequ?.length===0 && !innerLoading?
                <div className='notFoundWraper'>
                    <label style={{opacity:'0.8'}}>{t("No Requests Found")}</label>
                    <img src={notFound} alt='notFound' className='noutFoundImg'/>
                </div>:
                innerLoading?
                <Loading height='600px'/>:
                <div className='completed' style={{width:'100%'}}>
            {completedRequ?.map(item=> 
                <RequItem key={item.REQ_ID} title={item.AIDTYPE_NAME_A} requestNumber={item.REQ_ID} year={item.REQ_YEAR} requClassi={item.CATGRP_NAME_A}/>
                )}
        </div>
            }
                
            </div>
        ) 
}

export default Completed
